<template>
  <div>
    <v-app
      :style="
        'background-color: ' +
        $vuetify.theme.themes[$vuetify.theme.dark ? 'dark' : 'light'].bg
      "
      v-if="$route.name !== 'Slideshow'"
    >
      <v-main>
        <div
          class="Vue-Toastification__container top-right"
          style="opacity: 0.8"
          v-if="uploadProgress < 100"
        >
          <div
            class="Vue-Toastification__toast Vue-Toastification__toast--info top-right"
          >
            <div role="alert" class="Vue-Toastification__toast-body">
              Uploading file(s) to TPU ({{ uploadProgress }}%)...
            </div>
            <v-btn text small @click="this.cancel.abort()">Cancel</v-btn>
            <div
              class="Vue-Toastification__progress-bar"
              style="animation-play-state: paused; opacity: 1"
              :style="'width: ' + uploadProgress + '%'"
            ></div>
          </div>
        </div>
        <v-overlay :value="$store.state.site.loading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <Header
          v-if="
            ($store.state.site.maintenance && $store.state.user.admin) ||
            !$store.state.site.maintenance ||
            $route.name === 'Flowinity Authorize'
          "
        ></Header>
        <router-view
          v-if="
            ($store.state.site.maintenance && $store.state.user.admin) ||
            !$store.state.site.maintenance ||
            $route.name === 'Flowinity Authorize'
          "
        />
        <Maintenance
          v-if="$store.state.site.maintenance && !$store.state.user.admin"
        ></Maintenance>
        <Footer
          v-if="
            ($store.state.site.maintenance && $store.state.user.admin) ||
            !$store.state.site.maintenance ||
            $route.name === 'Flowinity Authorize'
          "
        ></Footer>
        <v-snackbar
          v-model="$store.state.errorHandler.enabled"
          :multi-line="true"
          :timeout="2500"
          :value="true"
          elevation="24"
        >
          <span v-for="item in $store.state.errorHandler.errors" :key="item">
            {{ item }}
          </span>
          <template v-slot:action="{ attrs }">
            <v-btn
              class="rounded-xl"
              color="blue"
              text
              v-bind="attrs"
              @click="$store.state.errorHandler.enabled = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-main>
    </v-app>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<style>
body {
  background-color: var(--v-bg-base);
}
.v-btn__content {
  text-transform: capitalize !important;
}
.center-nav {
  position: absolute;
  background-color: transparent;
  margin-left: auto !important;
  margin-right: auto !important;
  width: 100% !important;
  text-align: center !important;
}
.troploGradient {
  font-weight: 500;
  background: -webkit-radial-gradient(#096fea, #0166ea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-gradient-alt {
  font-weight: 500;
  background: -webkit-radial-gradient(#096fea, #0166ea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient {
  font-weight: 500;
  background: -webkit-radial-gradient(#0179f3, #0190ea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient-only {
  background: -webkit-radial-gradient(#0179f3, #0190ea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.v-card,
.v-sheet,
.v-window {
  background-color: var(--v-card-base) !important;
}

.v-toolbar {
  background-color: var(--v-toolbar-base) !important;
}

.card {
  overflow: hidden;
}
/* Works on Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: black #151515;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: #0e0e0e;
}

*::-webkit-scrollbar-thumb {
  background-color: #151515;
  border-radius: 20px;
  border: 3px solid #151515;
}
</style>
<script>
import Header from "./components/Header"
import Footer from "./components/Footer"
import Maintenance from "./components/Maintenance"
export default {
  components: {
    Header,
    Footer,
    Maintenance
  },
  name: "App",

  data: () => ({
    uploadProgress: 100,
    cancel: null
  }),
  mounted() {
    if (localStorage.getItem("theme")) {
      const user = {
        themeObject: JSON.parse(localStorage.getItem("theme"))
      }
      const name = user.themeObject.id
      const dark = user.themeObject.theme.dark
      const light = user.themeObject.theme.light
      this.$vuetify.theme.themes.dark = dark
      this.$vuetify.theme.themes.light = light
      this.$vuetify.theme.themes.name = name
      this.$vuetify.theme.themes.primaryType =
        user.themeObject.theme.primaryType
    }
    if (localStorage.getItem("attributes")) {
      this.$store.state.attributes = {
        ...this.$store.state.defaultAttributes,
        ...JSON.parse(localStorage.getItem("attributes"))
      }
    }
    if (localStorage.getItem("userCache")) {
      const user = JSON.parse(localStorage.getItem("userCache"))
      const name = user.themeObject.id
      const dark = user.themeObject.theme.dark
      const light = user.themeObject.theme.light
      this.$vuetify.theme.themes.dark = dark
      this.$vuetify.theme.themes.light = light
      this.$vuetify.theme.themes.name = name
      this.$vuetify.theme.themes.primaryType =
        user.themeObject.theme.primaryType
      localStorage.setItem("theme", JSON.stringify(user.themeObject))
      if (this.$store.state.site.enterprise) {
        _paq.push(["setUserId", this.$store.state.user.id])
        _paq.push(["trackPageView"])
      }
      document.title = this.$store.state.site.name
      if (user.description.includes("enableTroploThemeOverride")) {
        this.$store.commit("setWhitelabel", true)
      }
      if (user.description.includes("enableBrandThemeOverride")) {
        this.$store.commit("setWhitelabel", false)
      }
      this.$store.commit("login", user)
      if (user.subscription) {
        this.$store.commit("setSubscription", user)
      }
      this.$vuetify.theme.dark = user.darkTheme
      this.$store.commit("setDiscordCache", JSON.parse(user.discordUserCache))
    }
    this.$vuetify.theme.dark = this.$store.state.user.darkTheme
    if (window.location.pathname.startsWith("/slideshow")) return
    this.$store.commit("updateToken", localStorage.getItem("token"))
    if (!["sidebar", "navbar"].includes(localStorage.getItem("navigation"))) {
      localStorage.removeItem("navigation")
      localStorage.setItem("navigation", "sidebar")
    }
    this.$store.commit("updateNavigation", localStorage.getItem("navigation"))
    Object.assign(this.axios.defaults, {
      headers: { Authorization: this.$store.state.user.token }
    })
    this.$store.dispatch("quickSwitchCache")

    document.addEventListener("paste", (e) => {
      if (!this.$store.state.experiments["INSTANT_UPLOAD"]) return
      console.info("[TPU/InstantUpload] Paste detected")
      if (this.uploadProgress < 100) return
      if (e.clipboardData && e.clipboardData.files.length) {
        const files = e.clipboardData.files
        const formData = new FormData()
        for (const file of files) {
          formData.append("attachments", file)
        }
        this.cancel = new AbortController()
        this.axios
          .post("/api/v1/gallery/upload/site", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            },
            signal: this.cancel.signal,
            onUploadProgress: (progressEvent) => {
              this.uploadProgress = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              )
            }
          })
          .then((res) => {
            this.cancel = null
            this.uploadProgress = 100
            navigator.clipboard.writeText(res.data.links[0])
            this.$toast.success(
              "Files uploaded successfully (TPU link copied to clipboard)."
            )
          })
      }
    })

    this.$socket.on("autoCollectApproval", (data) => {
      if (this.$store.state.experiments["SFX_KFX"]) {
        new Audio(require("@/assets/audio/kfx.wav")).play()
      } else if (this.$store.state.experiments["SFX_KOLF"]) {
        new Audio(require("@/assets/audio/kolf.wav")).play()
      }
      if (data.type === "new") {
        this.$store.state.user.pendingAutoCollects += 1
      } else if (data.type === "approve") {
        this.$store.state.user.pendingAutoCollects -= 1
      }
    })
    this.$store.dispatch("setupExperiments")
    this.axios.get("/api/v1/site/state").then((res) => {
      this.$store.commit("state", res.data)
      this.$store.commit("setRoute", this.$route.name)
      if (this.$store.state.experiments["FORCE_DEV_MODE"])
        this.$store.state.site.release = "dev"
      if (this.$store.state.experiments["FORCE_STABLE_MODE"])
        this.$store.state.site.release = "prod"
      if (this.$store.state.site.enterprise) {
        _paq.push(["setSiteId", this.$store.state.site.matomoId])
        _paq.push(["trackPageView"])
      }
      this.axios
        .get("/api/v1/userutils/info")
        .then((res) => {
          const user = res.data
          const name = user.themeObject.id
          const dark = user.themeObject.theme.dark
          const light = user.themeObject.theme.light
          this.$vuetify.theme.themes.dark = dark
          this.$vuetify.theme.themes.light = light
          this.$vuetify.theme.themes.name = name
          this.$vuetify.theme.themes.primaryType =
            user.themeObject.theme.primaryType
          localStorage.setItem("theme", JSON.stringify(user.themeObject))
          if (this.$store.state.site.enterprise) {
            _paq.push(["setUserId", this.$store.state.user.id])
            _paq.push(["trackPageView"])
          }
          document.title =
            this.$route.name + " - " + this.$store.state.site.name
          if (res.data.description.includes("enableTroploThemeOverride")) {
            this.$store.commit("setWhitelabel", true)
          }
          if (
            res.data.description.includes("enableBrandThemeOverride") ||
            this.$store.state.experiments["NON_TPU_BRANDING"]
          ) {
            this.$store.commit("setWhitelabel", false)
          }
          this.$store.commit("login", res.data)
          if (res.data.subscription) {
            this.$store.commit("setSubscription", res.data)
          }
          this.$vuetify.theme.dark = res.data.darkTheme
          this.$store.commit(
            "setDiscordCache",
            JSON.parse(res.data.discordUserCache)
          )
          localStorage.setItem(
            "userCache",
            JSON.stringify({
              ...res.data,
              apiKey: null
            })
          )
        })
        .catch(() => {
          /*if (this.$store.state.user?.id) {
            this.$store.commit("devLogin", "")
            this.$store.commit("updateToken", "")
            localStorage.removeItem("token")
            localStorage.removeItem("userCache")
            Object.assign(this.axios.defaults, {
              headers: { Authorization: this.$store.state.user.token }
            })
            this.$router.push("/")
          }*/
          /* if (this.$store.state.site.enterprise) {
            if (
              ![
                "Attachment",
                "Bio",
                "Flowinity Authorize",
                "Password Reset",
                "Collection Share"
              ].includes(this.$route.name)
            ) {
              window.location.href =
                "https://sso.flowinity.com/auth/realms/master/protocol/openid-connect/auth?client_id=" +
                this.$store.state.site.flowinityId +
                "&redirect_uri=" +
                this.$store.state.site.hostnameWithProtocol +
                "%2FflowinityAuthorize%2Flogin&response_type=code"
            }
          }*/
        })
    })
  },
  watch: {
    $route(to) {
      this.$store.commit("setRoute", to.name)
      if (!to.name) document.title = this.$store.state.site.name
      document.title = to.name + " - " + this.$store.state.site.name
    }
  }
}
</script>
